// extracted by mini-css-extract-plugin
export var closeButton = "_pp-2";
export var closeButtonIcon = "_pp-3";
export var lightboxContent = "_pp-1";
export var lightboxOverlay = "_pp-0";